import { jsx as c } from "react/jsx-runtime";
import s, { useEffect as g } from "react";
import { c as h, u as k } from "../chunks/useClickMotion.0a3ea4e5.js";
import { a as b, b as y } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import u, { css as l } from "styled-components";
import { R as x } from "../chunks/index.cff5baaf.js";
const C = u.button.withConfig({
  displayName: "ButtonFavorite",
  componentId: "sc-136kufj-0"
})(["", " all:unset;width:var(--size-6x);height:var(--size-6x);display:flex;align-items:center;justify-content:center;border-radius:var(--default-border-radius);flex:0 0 auto;transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-02);&:hover{", " border:none;cursor:pointer;transition-timing-function:var(--curve-productive-entrance);}&:focus-visible,:focus,:focus-within{", " outline-offset:2px;}", " ", ""], (o) => o.$isClickMotion && h("300%"), b, y, (o) => o.disabled && l(["opacity:var(--opacity-low);cursor:not-allowed;pointer-events:none;", "{color:var(--disabled-icon-color);}"], e), (o) => o.selected && l(["", "{color:var(--selected-icon-color);}"], e)), e = u(x).withConfig({
  displayName: "Icon",
  componentId: "sc-136kufj-1"
})(["z-index:1;"]), w = s.forwardRef(({
  disabled: o = !1,
  selected: t = !1,
  ariaLabel: f,
  onClick: n,
  ...d
}, p) => {
  const [i, r] = s.useState(t), {
    isClickMotion: v,
    startClickMotion: m
  } = k();
  return g(() => {
    r(t);
  }, [t]), /* @__PURE__ */ c(C, { disabled: o, selected: i, "aria-disabled": o, $isClickMotion: v, "aria-label": f, "data-rango-component": "rango-button-favorite", "data-is-rango": !0, ...d, ref: p, onClick: (a) => {
    if (o) {
      a.preventDefault();
      return;
    }
    n && n(a), r(!i), m();
  }, "data-testid": "rango-button-favorite", children: /* @__PURE__ */ c(e, { icon: i && !o ? "FavoriteSelected" : "FavoriteLine" }) });
});
w.displayName = "RangoButtonFavorite";
export {
  w as RangoButtonFavorite
};
